import { LicensesBillingStatuses } from "../../constants/licenses";
import { calculateDiffDays, concatTime, formatDate } from "../../utils/date";

export function LicenseExpirationDate({ license, ...props }) {
   if (!license) {
      return;
   }
   if (!license.currentBilling) {
      return (
         <span className="opacity-40 text-xs!">
            Indefinido
         </span>
      );
   }
   const dueDate = new Date(concatTime(license.currentBilling.dueDate));
   const diffDays = calculateDiffDays(new Date(), dueDate);
   let billingStatusKey = license.currentBilling.status;

   if (billingStatusKey !== 'PAID') {
      if (diffDays < 0) {
         billingStatusKey = 'OVERDUE';
      } else if (diffDays < 10) {
         billingStatusKey = 'EXPIRING';
      }
   }
   const billingStatus = LicensesBillingStatuses[billingStatusKey];

   return (
      <span className="inline-flex flex-col gap-2" style={{ '--statusColor': billingStatus.color }}>
         <span>{formatDate(dueDate)}</span>
         <span className="text-(--statusColor)! font-semibold!">{diffDays < 0 ? 'Há ' : ''}{Math.abs(diffDays)} dias</span>
      </span>
   );
}